export default __webpack_public_path__ + "static/media/adopt-a-school.377eccd0.png";